import { createFileRoute } from '@tanstack/react-router';
import { JourneysReportingWebhooksHandoff } from '@/pages/workspaces/journeys/integrations/reporting-webhooks/routing';

function JourneysNewReportingWebhookRoute() {
  return <JourneysReportingWebhooksHandoff kind="new" />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new',
)({
  component: JourneysNewReportingWebhookRoute,
});
